module.exports = __webpack_public_path__ + "static/salt-dca4fe9bcbc096ea30ca13ad5d11fbca.png";